import { render, staticRenderFns } from "./UserAndShopDetails.vue?vue&type=template&id=f0ed0daa&"
import script from "./UserAndShopDetails.vue?vue&type=script&lang=js&"
export * from "./UserAndShopDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports